module.exports = __webpack_public_path__ + "static/scale-model-of-sterling-heights-michigan-f776a18e20615d332c380106858af686.png";